import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { Typography } from '@material-ui/core';

const headStyles = makeStyles(theme => ({
    headFont: {
        fontSize: 13,
        fontWeight: 600
    },
    fontBold: {
        fontWeight: 600
    }
}));

/**
 * EnhancedTableHead
 * @param props
 * @return {*}
 * @constructor
 */
function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    const headClasses = headStyles();

    const headRows = [
        { id: 'mersisNo', numeric: false, disablePadding: false, label: 'Şirket Mersis No' },
        { id: 'shareOrderNo', numeric: false, disablePadding: false, label: 'Tertip' },
        { id: 'shareGroupNo', numeric: false, disablePadding: false, label: 'Grup' },
        { id: 'shareNominalValue', numeric: true, disablePadding: false, label: 'İtibari değer' },
        { id: 'shareAmount', numeric: true, disablePadding: false, label: 'Pay Adedi' },
        { id: 'shareTotalValue', numeric: true, disablePadding: false, label: 'Pay Tutarı (TL)' },
        { id: 'shareSerialNo', numeric: true, disablePadding: false, label: 'Sıra No' },
        { id: 'mkkCertRef', numeric: true, disablePadding: false, label: 'MKK Referans No' },
        { id: 'explanation', numeric: true, disablePadding: false, label: 'Açıklama ' },
        { id: 'recordStatus', numeric: true, disablePadding: false, label: 'Kayıt Durumu ' },
    ];

    return (
        <TableHead>
            <TableRow>
                {headRows.map(row => (
                    <TableCell
                        key={row.id}
                        align={row.numeric ? 'right' : 'left'}
                        padding={row.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === row.id ? order : false}
                        className={headClasses.headFont}
                    >
                        <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={createSortHandler(row.id)}
                        >
                            {
                                row.secondLabel ?
                                    <div>
                                        {row.label}<br />
                                        <Typography classes={{ subtitle1: headClasses.fontBold }}
                                                    variant="subtitle1">{row.secondLabel}</Typography>
                                    </div>
                                    :
                                    <div>{row.label}</div>
                            }
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
};

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    fontSize13: {
        fontSize: 13
    },
    link: {
        color: '#aa3323'
    }
}));
/**
 * TransferInfoTable
 * @param props
 * @return {*}
 * @constructor
 */
export default function TransferInfoTable(props) {
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('memberTooltip');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const rows = props.accInfoData;

    /**
     * handleRequestSort
     * @param event
     * @param property
     */
    function handleRequestSort(event, property) {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    }

    /**
     * handleChangePage
     * @param event
     * @param newPage
     */
    function handleChangePage(event, newPage) {
        setPage(newPage);
    }

    /**
     * handleChangeRowsPerPage
     * @param event
     */
    function handleChangeRowsPerPage(event) {
        setRowsPerPage(+event.target.value);
        setPage(0);
    }

    return (
        <div>
            <div className={classes.tableWrapper} id="transferTable">
                <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    size={'medium'}
                >
                    <EnhancedTableHead
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        rowCount={rows.length}
                        intl={props.intl}
                    />
                    <TableBody>
                        {rows.map((row, i) => {
                            return (
                                <TableRow
                                    hover
                                    tabIndex={-1}
                                    key={'row' + i}
                                >
                                    <TableCell align="left" key={'mersisNo_' + i}
                                               id={'mersisNo_' + i}>{row.mersisNo}</TableCell>
                                    <TableCell align="left" key={'shareOrderNo_' + i}
                                               id={'shareOrderNo_' + i}>{row.shareOrderNo}</TableCell>
                                    <TableCell align="left" key={'shareGroupNo_' + i}
                                               id={'shareGroupNo_' + i}>{row.shareGroupNo}</TableCell>
                                    <TableCell align="right" key={'shareNominalValue_' + i}
                                               id={'shareNominalValue_' + i}>{row.shareNominalValue}</TableCell>
                                    <TableCell align="right" key={'shareAmount_' + i}
                                               id={'shareAmount_' + i}>{row.shareAmount}</TableCell>
                                    <TableCell align="right" key={'shareTotalValue_' + i}
                                               id={'shareTotalValue_' + i}>{row.shareTotalValue}</TableCell>
                                    <TableCell align="right" key={'shareSerialNo_' + i}
                                               id={'shareSerialNo_' + i}>{row.shareSerialNo}</TableCell>
                                    <TableCell align="right" key={'mkkCertRef_' + i}
                                               id={'mkkCertRef_' + i}>{row.mkkCertRef}</TableCell>
                                    <TableCell align="right" key={'explanation_' + i}
                                               id={'explanation_' + i}>{row.explanation}</TableCell>
                                    <TableCell align="right" key={'recordStatus_' + i}
                                               id={'recordStatus_' + i}>{row.recordStatus}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </div>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonText={props.intl.formatMessage({ id: "TABLE.PAGINATION.PREVIOUS" })}
                nextIconButtonText={props.intl.formatMessage({ id: "TABLE.PAGINATION.NEXT" })}
                labelRowsPerPage={props.intl.formatMessage({ id: "TABLE.PAGINATION.PER_PAGE" })}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </div>
    )
}